import QuoteBuilderLayout from './QuoteBuilderLayout';
import SelectUnit from './SelectUnit';
import SelectQuantity from './SelectQuantity';
import OptionLengthWithUnit from './OptionLengthWithUnit';
import OptionBoolean from './OptionBoolean';
import OptionIntegerWithRange from './OptionIntegerWithRange';
import DrawingMaterialChooser from './DrawingMaterialChooser';
import SubmitButton from './SubmitButton';

export default {
  maxWidth: 800,
  defaultHighlightColor: '#00d4ff',
  QuoteBuilderLayout,
  SelectUnit,
  SelectQuantity,
  OptionLengthWithUnit,
  OptionBoolean,
  OptionIntegerWithRange,
  DrawingMaterialChooser,
  SubmitButton,
};
